<form class="content" [formGroup]="form">
  <section class="content--item">
    <h5 class="content--title" *ngIf="selectedSubtype">
      {{ 'projectInfo' | i18next }}
    </h5>
    <h5 class="content--title" *ngIf="!selectedSubtype">
      {{ 'selectedSubtype' | i18next }}
    </h5>
    <mat-form-field class="form-single-column">
      <mat-label>{{ 'requestSubtype' | i18next }}</mat-label>
      <mat-select
        formControlName="subtype"
        (selectionChange)="onSubtypeChange()"
      >
        <mat-option [value]="projectTypeEnum.NEW">{{
          'gsOriginNew' | i18next
        }}</mat-option>
        <mat-option [value]="projectTypeEnum.REGU">{{
          'summaryQuotaRegularization' | i18next
        }}</mat-option>
        <mat-option [value]="projectTypeEnum.OTHER">{{
          'otherBrands' | i18next
        }}</mat-option>
      </mat-select>
    </mat-form-field>
    <div class="form-two-columns" *ngIf="showAreaAndDepartament">
      <mat-form-field>
        <mat-label>{{ 'area' | i18next }}</mat-label>
        <mat-select formControlName="area" (selectionChange)="areaChange()">
          <mat-option *ngFor="let area of areas" [value]="area.id">
            {{ area.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'requestPetitionerDependency' | i18next }}</mat-label>
        <mat-select
          formControlName="departament"
          (selectionChange)="depChange()"
          [disabled]="true"
        >
          <mat-option
            *ngFor="let departament of departaments"
            [value]="departament.id"
          >
            {{ departament.id + ' - ' + departament.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div *ngIf="form.value.subtype === projectTypeEnum.REGU">
      <div class="form-title">
        <h6 class="content--title">{{ 'searchVehicle' | i18next }}</h6>
      </div>
      <form
        [formGroup]="searchForm"
        style="
          justify-content: left;
          align-items: flex-end;
          display: flex;
          flex-wrap: wrap;
        "
      >
        <mat-form-field>
          <!-- Búsqueda por Bastidor -->
          <mat-label for="vin">{{ 'vin' | i18next }}</mat-label>
          <input
            matInput
            type="text"
            class="form--input"
            name="vin"
            formControlName="vin"
            placeholder="{{ 'vin' | i18next }}"
          />
        </mat-form-field>

        <mat-form-field class="vehicleFinder--container__item">
          <mat-label for="plateNumber" class="form--label">{{
            'plateNumber' | i18next
          }}</mat-label>
          <input
            matInput
            type="text"
            class="form--input"
            name="plateNumber"
            formControlName="plateNumber"
            placeholder="{{ 'plateNumber' | i18next }}"
          />
        </mat-form-field>

        <!-- Botón de búsqueda -->
        <button
          type="button"
          class="form-two-columns--btn"
          (click)="onSearch()"
          [disabled]="
            (!searchForm.value.vin && !searchForm.value.plateNumber) ||
            vehicles.length > 0
          "
          [ngStyle]="
            (!searchForm.value.vin && !searchForm.value.plateNumber) ||
            vehicles.length > 0
              ? { 'background-color': '#efffc1', 'font-weight': 'normal' }
              : { 'background-color': '#c8f546' }
          "
        >
          {{ 'btnSearch' | i18next | uppercase }}
        </button>
      </form>
      <div class="error-message">
        <small *ngIf="searchError">
          {{ 'searchError' | i18next }}
        </small>
      </div>
      <div class="error-message">
        <small *ngIf="vinRepeat">
          {{ 'existingVehicle' | i18next }}
        </small>
      </div>
      <!-- Fieldset de resultados -->
      <section class="vehicleFinder" *ngIf="vehicles && vehicles.length > 0">
        <h6 class="vehicleFinder--title">
          {{ 'infoVehiclePetitioner' | i18next }}
        </h6>
        <div class="resultContainer">
          <div
            *ngFor="let vehicle of vehicles; let i = index"
            class="vehicle-item"
          >
            <div class="resultContainer--header">
              <h4>{{ 'vehicle' | i18next }} {{ i + 1 }}</h4>
              <button
                type="button"
                class="btn btn-danger"
                (click)="removeVehicle(i)"
              >
                {{ 'delete' | i18next | uppercase }}
              </button>
            </div>
            <div class="resultContainer--details">
              <div class="resultContainer--details__section">
                <div class="resultContainer--details__section--item">
                  <label class="resultContainer--details__label">{{
                    'plateNumber' | i18next
                  }}</label>
                  <p>{{ vehicle.plateNumber || 'noData' | i18next }}</p>
                </div>
                <div class="resultContainer--details__section--item">
                  <label class="resultContainer--details__label">{{
                    'vin' | i18next
                  }}</label>
                  <p>{{ vehicle.vin || 'noData' | i18next }}</p>
                </div>
                <div class="resultContainer--details__section--item">
                  <label class="resultContainer--details__label">{{
                    'requestPccTMAIMG' | i18next
                  }}</label>
                  <p>{{ vehicle.tmaimg || 'noData' | i18next }}</p>
                </div>
                <div class="resultContainer--details__section--item">
                  <label class="resultContainer--details__label">{{
                    'model' | i18next
                  }}</label>
                  <p>
                    {{ vehicle.model || 'noData' | i18next }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="form-time-two-columns" *ngIf="showAreaAndDepartament">
      <div class="form-title">
        <h6 class="content--title">{{ 'enterVehicleData' | i18next }}</h6>
      </div>
      <mat-form-field>
        <mat-label>{{ 'projectNeedDate' | i18next }}</mat-label>
        <input
          matInput
          [matDatepicker]="datePicker"
          formControlName="date"
          [min]="minDate"
          placeholder="DD/MM/YYYY"
        />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="datePicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #datePicker (closed)="close()"></mat-datepicker>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'projectAppraisalExpectedDate' | i18next }}</mat-label>
        <input
          matInput
          [matDatepicker]="picker"
          formControlName="returnDate"
          [min]="form.value.date"
          placeholder="DD/MM/YYYY"
        />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="picker"
        ></mat-datepicker-toggle>
        <mat-datepicker #picker (closed)="close()"></mat-datepicker>
      </mat-form-field>
    </div>
    <div
      class="form-two-columns"
      *ngIf="vehicles.length === 0 && showAreaAndDepartament && !stockVehicle"
    >
      <mat-form-field>
        <mat-label>{{ 'model' | i18next }}</mat-label>
        <input type="text" matInput formControlName="model" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'requestPccTMAIMG' | i18next }}</mat-label>
        <input type="text" matInput formControlName="tmaimg" maxlength="6" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'finishes' | i18next }}</mat-label>
        <input type="text" matInput formControlName="finish" />
      </mat-form-field>
      <mat-form-field *ngIf="showReguForm">
        <mat-label>{{ 'color' | i18next }}</mat-label>
        <input type="text" matInput formControlName="color" />
      </mat-form-field>
    </div>
    <div class="form-two-columns" *ngIf="showAreaAndDepartament">
      <div class="form-checkbox-launch">
        <mat-label class="content--checkbox">
          {{ 'launchCosts' | i18next }}
        </mat-label>
        <mat-checkbox formControlName="launch" class="mat-checkbox-force-color">
        </mat-checkbox>
      </div>
      <mat-form-field>
        <mat-label>{{ 'dealerCode' | i18next }}</mat-label>
        <input
          matInput
          type="text"
          formControlName="dealerCode"
          [matAutocomplete]="auto"
        />
        <mat-autocomplete
          #auto="matAutocomplete"
          (optionSelected)="updateDealerCodeAC($event)"
          [displayWith]="displayDealerFn"
        >
          <mat-option *ngFor="let dealer of filteredDealers" [value]="dealer">
            {{ dealer.name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'ceco' | i18next }}</mat-label>
        <mat-select formControlName="ceco">
          <mat-option *ngFor="let ceco of cecos" [value]="ceco">
            {{ ceco }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field *ngIf="showNewForm">
        <mat-label>{{ 'exteriorColor' | i18next }}</mat-label>
        <input
          type="text"
          matInput
          formControlName="exteriorColor"
          maxlength="4"
        />
      </mat-form-field>
      <mat-form-field *ngIf="showNewForm">
        <mat-label>{{ 'interiorColor' | i18next }}</mat-label>
        <input
          type="text"
          matInput
          formControlName="interiorColor"
          maxlength="2"
        />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'EA' | i18next }}</mat-label>
        <input type="text" matInput formControlName="ea" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'orderReference' | i18next }}</mat-label>
        <input type="text" matInput formControlName="reference" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'sop' | i18next }}</mat-label>
        <input
          matInput
          [matDatepicker]="sopPicker"
          formControlName="sop"
          placeholder="DD/MM/YYYY"
        />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="sopPicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #sopPicker (closed)="closeSop()"></mat-datepicker>
      </mat-form-field>
      <mat-form-field id="cops-anchor">
        <mat-label>{{ 'cops' | i18next }}</mat-label>
        <input type="text" matInput formControlName="cops" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'vds' | i18next }}</mat-label>
        <input type="text" matInput formControlName="vds" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'appraisalExpectedKm' | i18next }}</mat-label>
        <input type="number" matInput formControlName="kms" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'bnr' | i18next }}</mat-label>
        <input type="text" matInput formControlName="bnr" />
      </mat-form-field>
      <mat-form-field
        *ngIf="vehicles.length === 0 && showAreaAndDepartament && !stockVehicle"
      >
        <mat-label>{{ 'requestPccCountry' | i18next }}</mat-label>
        <input type="text" matInput formControlName="country" maxlength="3" />
      </mat-form-field>
    </div>
    <div
      class="form-two-columns"
      *ngIf="vehicles.length === 0 && showAreaAndDepartament && !stockVehicle"
    >
      <mat-form-field>
        <mat-label>{{ 'requestPccMY' | i18next }}</mat-label>
        <input type="text" matInput formControlName="my" maxlength="4" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'usePreview' | i18next }}</mat-label>
        <input type="text" matInput formControlName="use" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'destination' | i18next }}</mat-label>
        <input type="text" matInput formControlName="destination" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'optionals' | i18next }}</mat-label>
        <input type="text" matInput formControlName="optionals" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'prNumbers' | i18next }}</mat-label>
        <input type="text" matInput formControlName="prNumbers" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'prEngine' | i18next }}</mat-label>
        <input type="text" matInput formControlName="prMotor" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'engineDescription' | i18next }}</mat-label>
        <input type="text" matInput formControlName="descriptionEngine" />
      </mat-form-field>
      <mat-form-field
        *ngIf="showReguForm && vehicles.length === 0 && !stockVehicle"
      >
        <mat-label>{{ 'orderNumber' | i18next }}</mat-label>
        <input type="number" matInput formControlName="orderNumber" />
      </mat-form-field>
    </div>
    <div class="form-two-columns" *ngIf="showAreaAndDepartament">
      <mat-form-field
        *ngIf="showReguForm && vehicles.length === 0 && !stockVehicle"
      >
        <mat-label>{{ 'vinNumber' | i18next }}</mat-label>
        <input type="text" matInput formControlName="vin" maxlength="17" />
      </mat-form-field>
      <div class="checkbox">
        <mat-label class="content--checkbox">
          {{ 'registeredSN' | i18next }}
        </mat-label>
        <mat-checkbox formControlName="registered"> </mat-checkbox>
      </div>
    </div>
    <div class="form-two-columns" *ngIf="showNewForm">
      <div class="form-title">
        <h6 class="content--title">{{ 'preseriesData' | i18next }}</h6>
      </div>
      <mat-form-field>
        <mat-label>{{ 'specialType' | i18next }}</mat-label>
        <mat-select
          formControlName="specialType"
          (selectionChange)="onSpecialTypeChange()"
        >
          <mat-option value="PROTOTYPE">{{ 'prototype' | i18next }}</mat-option>
          <mat-option value="PRESERIE">{{ 'preseries' | i18next }}</mat-option>
          <mat-option value="PRE_PRESERIE">{{
            'prePreseries' | i18next
          }}</mat-option>
          <mat-option value="SERIE">{{ 'series' | i18next }}</mat-option>
          <mat-option value="ZEROSERIE">{{ 'series0' | i18next }}</mat-option>
          <mat-option value="PRESS">{{
            'pressAndSalons' | i18next
          }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field *ngIf="form.value.specialType === 'PRESS'">
        <mat-label>{{ 'pressSubtype' | i18next }}</mat-label>
        <mat-select formControlName="pressSubtype">
          <mat-option> </mat-option>
          <mat-option value="SUBSTITUTION">{{
            'substitution' | i18next
          }}</mat-option>
          <mat-option value="ADDITIONAL">{{
            'additional' | i18next
          }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'materialType' | i18next }}</mat-label>
        <mat-select formControlName="materialType">
          <mat-option value="CARRIAGE">{{ 'bodywork' | i18next }}</mat-option>
          <mat-option value="VEHICLE">{{ 'vehicle' | i18next }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'preseriesType' | i18next }}</mat-label>
        <mat-select
          formControlName="preseriesType"
          (selectionChange)="onPreseriesTypeChange()"
        >
          <mat-option value="VFF">{{ 'VFF' | i18next }}</mat-option>
          <mat-option value="PVS">{{ 'PVS' | i18next }}</mat-option>
          <mat-option value="ZEROSERIE">{{ 'series0' | i18next }}</mat-option>
          <mat-option value="EMPTY">{{ 'NA' | i18next }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'subtypeSeries' | i18next }}</mat-label>
        <mat-select formControlName="subtypeSeries">
          <mat-option> </mat-option>
          <mat-option value="DEVELOPMENT">{{
            'developmentSeries' | i18next
          }}</mat-option>
          <mat-option value="MISCELLANEOUS">{{
            'variousSeries' | i18next
          }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'projectType' | i18next }}</mat-label>
        <mat-select
          formControlName="projectType"
          (selectionChange)="onProjectTypeChange()"
        >
          <mat-option> </mat-option>
          <mat-option value="BASE_PROJECT">{{
            'baseProject' | i18next
          }}</mat-option>
          <mat-option value="PA">{{ 'PA' | i18next }}</mat-option>
          <mat-option value="MY_MP">{{ 'modelpflege' | i18next }}</mat-option>
          <mat-option value="EMPTY">{{ 'NA' | i18next }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'projectML' | i18next }}</mat-label>
        <input type="text" matInput formControlName="projectML" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'preseriesCost' | i18next }}</mat-label>
        <input
          type="number"
          matInput
          formControlName="preseriesCost"
          readonly
        />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'seriesCost' | i18next }}</mat-label>
        <input type="number" matInput formControlName="seriesCost" readonly />
      </mat-form-field>
      <div class="checkbox">
        <mat-label class="content--checkbox">
          {{ 'transferToThird' | i18next }}
        </mat-label>
        <mat-checkbox formControlName="transferToThird"> </mat-checkbox>
      </div>
      <div>
        <button
          class="form-two-columns--btn"
          mat-button
          [disabled]="
            form.value.specialType === 'PROTOTYPE' ||
            form.value.specialType === 'SERIE' ||
            form.value.specialType === 'ZEROSERIE' ||
            form.value.specialType === 'PRE_PRESERIE' ||
            (form.value.specialType === 'PRESERIE' &&
              form.value.projectType === 'EMPTY')
          "
          (click)="calculateCosts()"
        >
          {{ 'calculateCost' | i18next | uppercase }}
        </button>
        <p
          class="text-button"
          *ngIf="
            form.value.specialType === 'PROTOTYPE' ||
            form.value.specialType === 'SERIE' ||
            form.value.specialType === 'ZEROSERIE' ||
            form.value.specialType === 'PRE_PRESERIE' ||
            (form.value.specialType === 'PRESERIE' &&
              form.value.projectType === 'EMPTY')
          "
        >
          {{ 'textDisabledCalculateCost' | i18next }}
        </p>
      </div>
    </div>
    <div class="form-two-columns" *ngIf="showOtherForm">
      <div class="form-title">
        <h6 class="content--title">{{ 'enrollmentManagement' | i18next }}</h6>
      </div>
      <div class="form-checkbox">
        <mat-label class="content--checkbox">
          {{ 'checkedManagement' | i18next }}
        </mat-label>
        <mat-checkbox formControlName="checkedManagement"> </mat-checkbox>
      </div>
      <mat-form-field>
        <mat-label>{{ 'plateNumber' | i18next }}</mat-label>
        <input type="text" matInput formControlName="plateNumber" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'summaryVinNumberDate' | i18next }}</mat-label>
        <input
          matInput
          [matDatepicker]="plateNumberPicker"
          formControlName="plateNumberDate"
          placeholder="DD/MM/YYYY"
        />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="plateNumberPicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #plateNumberPicker (closed)="close()"></mat-datepicker>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'townHallCode' | i18next }}</mat-label>
        <input type="text" matInput formControlName="townHallCode" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'summaryInsuranceType' | i18next }}</mat-label>
        <input type="text" matInput formControlName="insuranceType" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'deliveryDate' | i18next }}</mat-label>
        <input
          matInput
          [matDatepicker]="deliveryPicker"
          formControlName="deliveryDate"
          placeholder="DD/MM/YYYY"
        />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="deliveryPicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #deliveryPicker (closed)="close()"></mat-datepicker>
      </mat-form-field>
      <div class="form-title">
        <h6 class="content--title">{{ 'requestedVehicle' | i18next }}</h6>
      </div>
      <mat-form-field>
        <mat-label>{{ 'brand' | i18next }}</mat-label>
        <input type="text" matInput formControlName="brand" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'model' | i18next }}</mat-label>
        <input type="text" matInput formControlName="model" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'projectNeedDate' | i18next }}</mat-label>
        <input
          matInput
          [matDatepicker]="datePicker"
          formControlName="date"
          [min]="minDate"
          placeholder="DD/MM/YYYY"
        />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="datePicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #datePicker (closed)="close()"></mat-datepicker>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'projectAppraisalExpectedDate' | i18next }}</mat-label>
        <input
          matInput
          [matDatepicker]="picker"
          formControlName="returnDate"
          [min]="form.value.date"
          placeholder="DD/MM/YYYY"
        />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="picker"
        ></mat-datepicker-toggle>
        <mat-datepicker #picker (closed)="close()"></mat-datepicker>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'specialType' | i18next }}</mat-label>
        <input type="text" matInput formControlName="specialType" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'materialType' | i18next }}</mat-label>
        <input type="text" matInput formControlName="materialType" />
      </mat-form-field>
      <div class="form-checkbox-launch">
        <mat-label class="content--checkbox">
          {{ 'launchCosts' | i18next }}
        </mat-label>
        <mat-checkbox formControlName="launch" class="mat-checkbox-force-color">
        </mat-checkbox>
      </div>
      <mat-form-field>
        <mat-label>{{ 'dealerCode' | i18next }}</mat-label>
        <input
          matInput
          type="text"
          formControlName="dealerCode"
          [matAutocomplete]="auto"
        />
        <mat-autocomplete
          #auto="matAutocomplete"
          (optionSelected)="updateDealerCodeAC($event)"
          [displayWith]="displayDealerFn"
        >
          <mat-option *ngFor="let dealer of filteredDealers" [value]="dealer">
            {{ dealer.name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'ceco' | i18next }}</mat-label>
        <mat-select formControlName="ceco">
          <mat-option *ngFor="let ceco of cecos" [value]="ceco">
            {{ ceco }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'color' | i18next }}</mat-label>
        <input type="text" matInput formControlName="color" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'orderReference' | i18next }}</mat-label>
        <input type="text" matInput formControlName="reference" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'appraisalExpectedKm' | i18next }}</mat-label>
        <input type="number" matInput formControlName="kms" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'finishes' | i18next }}</mat-label>
        <input type="text" matInput formControlName="finishes" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'engine' | i18next }}</mat-label>
        <input type="text" matInput formControlName="engine" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'usePreview' | i18next }}</mat-label>
        <input type="text" matInput formControlName="usePreview" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'cops' | i18next }}</mat-label>
        <input type="text" matInput formControlName="cops" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'vds' | i18next }}</mat-label>
        <input type="text" matInput formControlName="vds" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'projectDestination' | i18next }}</mat-label>
        <input type="text" matInput formControlName="destination" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'subtypeSeries' | i18next }}</mat-label>
        <input type="text" matInput formControlName="subtypeSeries" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'seriesCost' | i18next }}</mat-label>
        <input type="number" matInput formControlName="seriesCost" />
      </mat-form-field>
      <div class="form-title">
        <h6 class="content--title">{{ 'manufacturedVehicle' | i18next }}</h6>
      </div>
      <mat-form-field>
        <mat-label>{{ 'requestPccEmissions' | i18next }}</mat-label>
        <input type="number" matInput formControlName="emission" />
      </mat-form-field>
      <div class="form-title">
        <h6 class="content--title">{{ 'observations' | i18next }}</h6>
      </div>
      <mat-form-field>
        <mat-label>{{ 'email' | i18next }}</mat-label>
        <input type="text" matInput formControlName="email" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'phone' | i18next }}</mat-label>
        <input type="text" matInput formControlName="phone" />
      </mat-form-field>
    </div>
  </section>
</form>
